import { Box, Grid, Theme, Typography, createStyles, makeStyles } from '@material-ui/core';
import React from 'react';

interface IRowWithIcon {
	icon: JSX.Element;
	text: string;
}

export interface ISchemaItem {
	rowWithIcon?: IRowWithIcon[];
	dataElement: JSX.Element;
	title: string;
}
export interface IInformationData {
	icon: () => JSX.Element;
	schema: ISchemaItem[];
}

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			maxWidth: '100%',
		},
		flexDiv: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		root: {
			padding: theme.spacing(3),
			width: '100%',
			flexDirection: 'column',
			display: 'flex',
			position: 'relative',
		},
		title: {
			fontWeight: 'bold',
			marginBottom: '10px',
		},
		label: {
			fontSize: '16px',
			lineHeight: '25px',
		},
		section: {
			maxWidth: '400px',
			display: 'flex',
			flexDirection: 'column',
			margin: '0 30px 15px 25px',
			[theme.breakpoints.down(1615)]: {
				margin: '0 15px 15px 15px',
			},
			[theme.breakpoints.down(601)]: {
				maxWidth: '100%',
				width: '100%',
				margin: '0 0 15px 0',
			},
		},
		rowWithIcon: {
			alignItems: 'center',
			display: 'flex',
			position: 'relative',
			margin: '0 0 0 2px',
		},
		icon: {
			marginRight: '20px',
			width: '91px',
			height: '91px',
			borderRadius: '50%',
			backgroundColor: '#D6EDFD',
			justifyContent: 'center',
			alignItems: 'center',
			display: 'flex',
			marginBottom: '10px',
			[theme.breakpoints.down(1615)]: {
				marginRight: '10px',
			},
		},
		textEllipsis: {
			//width: '112.5px',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},
		infoBox: {
			padding: '2px',
			minHeight: '150px',
			background: '#ffffff',
			boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25)',
		},
		schemaRow: {
			'&:not(:last-child)': {
				marginBottom: '10px',
			},
		},
	})
);

const DetailsBox = (props: IInformationData) => {
	const { icon, schema } = props;
	const classes = useStyles();

	return (
		<>
			<Grid container className={[classes.infoBox, classes.container].join(' ')}>
				<Grid item className={classes.root}>
					<Grid container direction='row'>
						<div className={classes.icon}>{icon()}</div>
						<div className={classes.flexDiv}>
							{schema.map((item, index) => {
								return (
									<div className={classes.section} key={index}>
										<Typography className={['info-box-content-item', classes.title].join(' ')}>{item.title}</Typography>
										<div className={classes.schemaRow}>
											<span className={classes.label}>{item.dataElement}</span>
											<span className={classes.label}>
												{item.rowWithIcon && item.rowWithIcon.map((row) => {
													return (
														<div className={classes.rowWithIcon}>
															{row.icon}
															<div className={[classes.label].join(' ')} style={{ marginLeft: '5px' }}>
																{row.text}
															</div>
														</div>
													);
												})}
											</span>
										</div>
									</div>
								);
							})}
						</div>
					</Grid>
				</Grid>
			</Grid>
			<Box mt={3}></Box>
		</>
	);
};

export default DetailsBox;
